var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongodbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_8895)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36.2969,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#1D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.7969,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.068 76.1642L132.736 81.1764C133.336 82.1013 133.986 82.92 134.752 83.6824C136.996 85.8989 139.088 88.2645 141.014 90.7631C145.535 96.7002 148.585 103.293 150.763 110.424C152.069 114.78 152.779 119.249 152.832 123.767C153.05 137.275 148.42 148.874 139.083 158.514C137.564 160.043 135.923 161.445 134.177 162.708C133.252 162.708 132.814 161.998 132.433 161.345C131.739 160.134 131.277 158.804 131.071 157.424C130.743 155.79 130.527 154.155 130.633 152.468V151.705C130.558 151.543 129.743 76.5486 130.068 76.1642Z",
    fill: "#599636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.068 75.9986C129.958 75.7799 129.849 75.9455 129.74 76.0517C129.793 77.1454 129.411 78.1203 128.815 79.0515C128.158 79.9764 127.29 80.6858 126.418 81.4482C121.575 85.6417 117.762 90.7069 114.709 96.3721C110.647 103.997 108.554 112.168 107.96 120.77C107.688 123.873 108.941 134.822 109.919 137.982C112.588 146.368 117.381 153.396 123.59 159.496C125.115 160.964 126.746 162.327 128.433 163.636C128.924 163.636 128.977 163.198 129.09 162.873C129.305 162.178 129.469 161.468 129.58 160.749L130.674 152.58L130.068 75.9986Z",
    fill: "#6CAC48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.736 166.026C132.846 164.776 133.446 163.739 134.099 162.705C133.442 162.433 132.955 161.892 132.574 161.289C132.245 160.718 131.973 160.116 131.761 159.492C130.999 157.205 130.836 154.805 130.618 152.468V151.052C130.346 151.271 130.29 153.121 130.29 153.396C130.131 155.866 129.803 158.323 129.308 160.749C129.146 161.73 129.036 162.708 128.433 163.58C128.433 163.689 128.433 163.798 128.487 163.961C129.468 166.848 129.736 169.788 129.902 172.785V173.879C129.902 175.185 129.849 174.91 130.933 175.347C131.371 175.51 131.858 175.566 132.296 175.891C132.624 175.891 132.677 175.619 132.677 175.401L132.514 173.604V168.592C132.461 167.717 132.624 166.848 132.733 166.029L132.736 166.026Z",
    fill: "#C2BFBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_8895",
    x: 0.723999,
    y: 0.296875,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_8895"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_8895",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodbIcon);
export default __webpack_public_path__ + "static/media/mongodb_icon.d921a0619b9f7b193203e8183fc1d20a.svg";
export { ForwardRef as ReactComponent };